import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { ordererMethods } from "../api/apiMethods";
import {
    canManageOrderers,
    isOrdererAdminWithoutAuthorisedUnits,
} from "../common/helpers/municipalityRoles";
import { AuthenticatedUserContext } from "../contexts/AuthenticatedUserContext";
import { useQueryErrorHandling } from "../hooks/useQueryErrorHandling";
import useSelectedMunicipalityId from "../hooks/useSelectedMunicipalityId";
import { queryKeys } from "./queryKeys";

export const useAllOrderersQuery = (selectedUnitIds?: string[]) => {
    const { authUserData } = useContext(AuthenticatedUserContext);
    const municipalityId = useSelectedMunicipalityId();

    const query = useQuery({
        queryKey: queryKeys.orderer.search(municipalityId, selectedUnitIds),
        queryFn: () => {
            if (!authUserData) {
                throw new Error("No auth user data");
            }

            if (!municipalityId) {
                throw new Error("No municipality Id");
            }

            try {
                return ordererMethods(municipalityId).getAllOrderers(
                    selectedUnitIds
                );
            } catch (error: any) {
                throw new Error(error.message);
            }
        },
        select: ({ userlist }) => userlist,
        enabled:
            !!authUserData &&
            canManageOrderers(authUserData.municipalityRole) &&
            !isOrdererAdminWithoutAuthorisedUnits(
                authUserData.municipalityRole,
                municipalityId
                    ? authUserData.municipalityAuthorisedUnitCodesMap[
                          municipalityId
                      ]
                    : undefined,
            ),
        staleTime: Infinity,
    });

    useQueryErrorHandling(query, "Kunde inte hämta beställare.");

    return query;
};
